import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import bubbleUpEvents from '../../utilities/bubble-up-events';
import unpick from '../../../utilities/unpick';
import reformatValue from '../../utilities/reformat-value';

export default function SSNComponent(props) {
  const { onChange, isValid, replacePattern } = props;
  const p = unpick(props, ['ariaLabel', 'isValid', 'replacePattern', 'mask']);

  const eventProps = replacePattern
    ? {
        onChange(e) {
          bubbleUpEvents(e, [reformatValue(e, replacePattern.regExpString, replacePattern.newSubStr), onChange]);
        },
      }
    : '';

  return (
    <InputMask
      {...p}
      {...eventProps}
      type="tel"
      mask={props.mask || '999-99-9999'}
      maskChar={props.maskChar || ''}
      aria-label={props.ariaLabel || 'SSN'}
      aria-placeholder={props.placeholder || ''}
      aria-invalid={!isValid}
    />
  );
}

Component.propTypes = {
  onChange: PropTypes.func,
};

Component.defaultProps = {
  onChange: undefined,
};
